import { AiOutlineClose } from "react-icons/ai";
import toast from "react-hot-toast";
import { useTranslation } from "next-i18next";
import {
  otpMobileInitialValues,
  otpMobileValidationSchema,
} from "@/constants/Auth";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { TextError } from "../Helpers/InputContainer";
import { getCookie, setCookie } from "cookies-next";
import { signIn } from "next-auth/react";
import { useContext } from "react";
import AWSPersonalizeCtx from "@/contexts/aws-personalize/aws-personalize-context";
import { useCheckout } from "@/contexts/checkout";
import TurnstileRecaptcha from "@/components/turnstile/TurnstileRecaptcha";
import { useTurnstile } from "react-turnstile";
import { event_otp_verified } from "@/utils/gtm";

function OtpMobileModal({ Context }) {
  const {
    t,
    i18n: { language: locale },
  } = useTranslation("common");
  const turnstile = useTurnstile()
  const { firstActionAfterLoginHandler } = useContext(AWSPersonalizeCtx);
  const { dispatch } = useCheckout();

  const handleSubmit = async ({ otp, token }, { resetForm, setFieldValue }) => {
    const useremailphone = getCookie("email-phone") ? getCookie("email-phone") : null;
    if (useremailphone) {
      const login = await signIn("credentials", {
        flow: "otp",
        otpType: "login",
        useremailphone,
        otp,
        recaptchaToken: token,
        locale,
        redirect: false,
      });
      if (login?.ok) {
        fetch("/api/auth/sync-mage", { method: "POST" }).catch(() => {});
        event_otp_verified("login");
        toast.success(t("otpSuccessBanner"));
        toast.success(
          locale == "en"
            ? "User Logged In SuccesFully"
            : " تم تسجيل الدخول بنجاح"
        );
        dispatch({ type: "RESET_CHECKOUT" });
        resetForm();
        setCookie("email", null);
        firstActionAfterLoginHandler(); // for aws integration
        Context?.dispatch({ type: "otpMobileModal" });
        return;
      }
      toast.error(
        locale === "en"
          ? "The attempt failed, please try again."
          : "فشلة المحاوله برجاء المحاوله مره اخرى"
      );
      turnstile.reset();
      setFieldValue("token", "");
    }
    return;
  };
  return (
    <section className="fixed z-[3000] top-0 left-0 w-screen h-screen bg-lightblack flex items-center justify-center">
      <div className="bg-white p-3 rounded-md w-[600px] max-[600px]:w-full">
        <div className="flex items-center justify-between">
          <h1 className="text-lg font-extrabold">{t("VerificationCode")}</h1>
          <AiOutlineClose
            size={24}
            className="cursor-pointer"
            onClick={() => Context?.dispatch({ type: "otpMobileModal" })}
          />
        </div>
        <section>
          <p className="my-3 text-zinc-600">{t("OtpEmailMobileDescription")}</p>
          <Formik
            initialValues={otpMobileInitialValues}
            validationSchema={otpMobileValidationSchema(t)}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting, setFieldValue }) => (
              <Form>
                <div className="mb-2">
                  <label
                    className="block mb-1 font-semibold cursor-pointer"
                    htmlFor="otp_number"
                  >
                    {t("Otp")}
                  </label>
                  <div className="relative">
                    <Field
                      name="otp"
                      className="w-full p-2 border rounded-md outline-0"
                      placeholder={t("Otp")}
                      id="otp_number"
                    />
                  </div>
                  <ErrorMessage name="otp" component={TextError} />
                </div>
                <TurnstileRecaptcha
                  action='otp-mobile-login'
                  className='flex justify-center items-center p-2'
                  onVerify={(value) => {
                    setFieldValue('token', value);
                  }}
                />
                <button
                  disabled={isSubmitting}
                  type="submit"
                  className="w-full p-2 font-semibold text-white rounded-md disabled:cursor-not-allowed bg-blue campaign:bg-campaignAccent border-red hover:bg-lightred"
                >
                  {t(isSubmitting ? "Sending" : "Verify")}
                </button>
              </Form>
            )}
          </Formik>
        </section>
      </div>
    </section>
  );
}

export default OtpMobileModal;
